// Country-simulation defaults — the ONE module that says which scenario the
// app simulates by default (US-917 · R-6).
//
// The legacy tool always POSTs build_fiber_to_pplsqkm: 300 ("Build out fiber
// to 300 ppl/sqkm", ScorecardPanel.jsx:127), while the backend defaults the
// parameter to 0 when absent (views.py) — a different optimization mode with
// the real engine. Every trigger of the country simulation (Analysis panel's
// useCountryData, the report's DownloadScorecardButton) must build its body
// here so panel and report always simulate the same scenario as David's tool.
//
// US-918 (assumptions panel) parameterizes this module: editable assumptions
// will merge over these defaults, keeping one source of truth.

// Legacy default fiber build-out density (ppl/sqkm). Part of the backend
// cache key, so the US-919 warm sweep heats this exact body variant.
export const BUILD_FIBER_TO_PPLSQKM = 300;

// The default POST body for /country-data-range/ for one country.
export const countryRequestBody = (iso3) => ({
  country_name: iso3,
  build_fiber_to_pplsqkm: BUILD_FIBER_TO_PPLSQKM,
});
